import { Route, Routes } from 'react-router'
import { Login } from '../Login'
import { Logout } from '../Logout'

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  )
}
